'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'deer';
var width = 512;
var height = 512;
var aliases = [129420];
var unicode = 'f78e';
var svgPathData = ['M56 264l0 14.1 25 25 7 7 0 9.9 0 32 0 3.9-1.2 3.7L73.4 399.7 96.8 464l28.9 0-20.3-55.8L99.6 392 113 381.3l31-24.8 0-20.5 0-33.3 31.6 10.5L219.9 328l68.1 0 24 0 0 24 0 112 32 0 0-152.2c0-7.7 1.2-15.4 3.7-22.8l21.5-64.6 5.5-16.4 17.3 0 80 0 0-29.4L398.7 112l-36.9 0-26 86.9L330.8 216l-17.9 0L104 216c-26.5 0-48 21.5-48 48zM416 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z', 'M256 16l0-16L224 0l0 16 0 24c0 30.9 25.1 56 56 56l8 0 8 0 20.6 0-.3 .9L256 112l0 32 46.2 0L295 168l-191 0c-28.5 0-54.2 12.5-71.8 32.2C12.5 217.8 0 243.5 0 272l0 48 0 16 32 0 0-14.1 8 8 0 18.2L25.2 392.4l-2.6 7.9 2.9 7.9 32 88L63.2 512 80 512l80 0 34.3 0-11.7-32.2L156.4 408 183 386.7l9-7.2 0-10.2 16.4 5.5 3.7 1.2 3.9 0 48 0 0 112 0 24 24 0 80 0 24 0 0-24 0-176.2c0-2.6 .4-5.1 1.2-7.6L409.3 256l86.7 0 24 0 0-24 0-64 0-10.6-7.9-7.1-68-61.8C460.8 78.7 472 60.7 472 40l0-24 0-16L440 0l0 16 0 24c0 13.3-10.7 24-24 24l-8 0-61.4 0c3.5-7.3 5.4-15.4 5.4-24l0-24 0-16L320 0l0 16 0 24c0 13.3-10.7 24-24 24l-8 0-8 0c-13.3 0-24-10.7-24-24l0-24zM144 356.5l-31 24.8L99.6 392l5.9 16.2L125.7 464l-28.9 0L73.4 399.7l13.4-40.1 1.2-3.7 0-3.9 0-32 0-9.9-7-7-25-25L56 264c0-26.5 21.5-48 48-48l208.9 0 17.9 0 5.1-17.1 26-86.9 36.9 0L472 178.6l0 29.4-80 0-17.3 0-5.5 16.4L347.7 289c-2.4 7.3-3.7 15-3.7 22.8L344 464l-32 0 0-112 0-24-24 0-68.1 0-44.3-14.8L144 302.7l0 33.3 0 20.5zM416 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDeer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;